__turbopack_context__.v({
  "button": "ReservationOfferCard-module__PjOyaq__button",
  "detailsContainer": "ReservationOfferCard-module__PjOyaq__detailsContainer",
  "eyebrow": "ReservationOfferCard-module__PjOyaq__eyebrow",
  "heading6": "ReservationOfferCard-module__PjOyaq__heading6",
  "image": "ReservationOfferCard-module__PjOyaq__image",
  "infoBox": "ReservationOfferCard-module__PjOyaq__infoBox",
  "infoRow": "ReservationOfferCard-module__PjOyaq__infoRow",
  "infoSubtitle": "ReservationOfferCard-module__PjOyaq__infoSubtitle",
  "infoTitle": "ReservationOfferCard-module__PjOyaq__infoTitle",
  "marginBottomHalf": "ReservationOfferCard-module__PjOyaq__marginBottomHalf",
  "marginBottomThreeQuarters": "ReservationOfferCard-module__PjOyaq__marginBottomThreeQuarters",
  "photo": "ReservationOfferCard-module__PjOyaq__photo",
  "photoWrapper": "ReservationOfferCard-module__PjOyaq__photoWrapper",
  "photoWrapperDesktop": "ReservationOfferCard-module__PjOyaq__photoWrapperDesktop",
  "photoWrapperMobile": "ReservationOfferCard-module__PjOyaq__photoWrapperMobile",
  "styledTile": "ReservationOfferCard-module__PjOyaq__styledTile",
  "styledTileWide": "ReservationOfferCard-module__PjOyaq__styledTileWide",
  "title": "ReservationOfferCard-module__PjOyaq__title",
  "widePhoto": "ReservationOfferCard-module__PjOyaq__widePhoto",
  "widePhotoWrapper": "ReservationOfferCard-module__PjOyaq__widePhotoWrapper",
});
